/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalSystemCatalogDto } from './MedicalSystemCatalogDto';
import {
    instanceOfMedicalSystemCatalogDto,
    MedicalSystemCatalogDtoFromJSON,
    MedicalSystemCatalogDtoFromJSONTyped,
    MedicalSystemCatalogDtoToJSON,
} from './MedicalSystemCatalogDto';

/**
 * @type JobOccurrenceDtoTargetSystem
 * 
 * @export
 */
export type JobOccurrenceDtoTargetSystem = MedicalSystemCatalogDto;


export function JobOccurrenceDtoTargetSystemFromJSON(json: any): JobOccurrenceDtoTargetSystem {
    return JobOccurrenceDtoTargetSystemFromJSONTyped(json, false);
}

export function JobOccurrenceDtoTargetSystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobOccurrenceDtoTargetSystem {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...MedicalSystemCatalogDtoFromJSONTyped(json, true) };
    return  MedicalSystemCatalogDtoFromJSONTyped(json, true);
}

export function JobOccurrenceDtoTargetSystemToJSON(value?: JobOccurrenceDtoTargetSystem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfMedicalSystemCatalogDto(value)) {
        return MedicalSystemCatalogDtoToJSON(value as MedicalSystemCatalogDto);
    }

    return {};
}

/**
 * Check if a given object implements the JobOccurrenceDtoTargetSystem interface.
 */
export function instanceOfJobOccurrenceDtoTargetSystem(value: any): value is JobOccurrenceDtoTargetSystem {
    if (instanceOfMedicalSystemCatalogDto(value)) return true;
    return false;
}

